<template>
  <div>
    <section class="technical-drawing__section">
      <div class="th-hero-slider__inner">
        <div class="swiper-container __js_th-hero-slider">
          <div class="swiper-wrapper">
            <div class="th-hero-slider__slide swiper-slide">
              <div class="th-hero-slider__content" style="margin-top: 30px">
                <div class="th-hero-slider__heading">
                  Cruz Roja Mexicana <br />Delegación Chihuahua
                </div>
                <div class="th-hero-slider__text">
                  Todos los días la Cruz Roja Mexicana es protagonista de una
                  historia en la que la vida triunfa.
                </div>
                <router-link
                  class="th-hero-slider__btn btn btn--technical"
                  to="/unidades-medicas"
                  >encuentra tu unidad médica más cercana</router-link
                >
              </div>
              <div class="th-hero-slider__image">
                <img src="@/assets/img/home.jpg" alt="" />
                <div class="th-hero-slider__circle">
                  <img src="@/assets/logo.svg" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- <section id="facturacion-diciembre-2025" class="technical-drawing__section">
      <div
        class="th-hero-slider__inner th-our-story__text container"
        style="
          border: #e20338;
          border-style: solid;
          border-width: 5px;
          border-radius: 20px;
          display: block;
          padding: 20px;
          margin-top: 15px;
          margin-bottom: 15px;
        "
      >
        <div class="heading" style="">¡Importante!</div>
        <div class="th-hero-slider__heading heading">
          Información sobre
          <a
            style="color: #e20338 !important"
            class="th-hero-slider__heading heading"
            >facturación</a
          >
        </div>
        <p style="font-size: 16px; line-height: 1.6">
          Todas las <b>facturas solicitadas</b> a partir del jueves
          <a class="isAlert">25 de diciembre del 2025</a>
          se emitirán con fecha correspondiente al mes de
          <a class="isAlert">Enero del 2026.</a>
        </p>
      </div>
    </section> -->

    <citas-aviso />
    <section class="technical-drawing__section th-our-story">
      <div class="th-our-story__inner">
        <div class="th-our-story__exp">
          <div class="th-our-story__exp-title">
            voluntarios que hacen esto posible
          </div>
          <div class="th-our-story__exp-value">168</div>
        </div>
        <div class="th-our-story__content">
          <div class="th-our-story__text">
            Una de las razones por las que la Cruz Roja se ha convertido en la
            organización que somos es debido a que conectamos con la gente y las
            comunidades en todo el país y en todo el mundo.
          </div>
          <div class="th-our-story__buttons">
            <router-link
              class="th-our-story__btn btn btn--technical"
              to="/sobre-nosotros"
              >conoce más sobre nosotros</router-link
            >
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import CitasAviso from "@/components/CitasAviso.vue";
export default {
  name: "Home",
  components: { CitasAviso },
};
</script>
